import {engineContext} from './context.js';

(function(global){
'use strict';
const VERSION='0.1.0-alpha';

const DEFAULTS=Object.freeze({
  PRICE:24,
  NEWS:48,
  EVENT:72,
  MACRO:168,
  FUNDAMENTAL:2160,
  OWNERSHIP:720,
  ECOSYSTEM:720,
  UNKNOWN:168
});

function normalize(x){
  x=x||{};
  const type=Object.prototype.hasOwnProperty.call(DEFAULTS,x.type)?x.type:'UNKNOWN';
  return Object.freeze({
    id:x.id||null,
    type,
    ageHours:Number.isFinite(x.ageHours)?Math.max(0,x.ageHours):null,
    verified:x.verified===true,
    sourceDate:x.sourceDate||null
  });
}
function status(input){
  const x=normalize(input);
  const limit=DEFAULTS[x.type];
  if(x.ageHours===null) return 'UNKNOWN';
  if(x.ageHours<=limit) return x.verified?'FRESH':'FRESH_UNVERIFIED';
  if(x.ageHours<=limit*2) return 'AGING';
  return 'STALE';
}
function factor(input){
  const x=normalize(input), s=status(x);
  if(s==='FRESH') return 1;
  if(s==='FRESH_UNVERIFIED') return .6;
  if(s==='AGING') return .55;
  if(s==='STALE') return .25;
  return .4;
}
function refreshNeeded(input){
  const s=status(input);
  return s==='STALE'||s==='UNKNOWN'||s==='FRESH_UNVERIFIED';
}
function bundle(items){
  const rows=Array.isArray(items)?items:[];
  const out=rows.map(x=>Object.freeze({...normalize(x),status:status(x),factor:factor(x),refreshNeeded:refreshNeeded(x)}));
  return Object.freeze({
    items:Object.freeze(out),
    stale:Object.freeze(out.filter(x=>x.status==='STALE')),
    refresh:Object.freeze(out.filter(x=>x.refreshNeeded)),
    tradeSignal:false
  });
}
function selfTest(){
  const t=[],ok=(n,p)=>t.push({name:n,pass:!!p});
  ok('fresh price evidence detected',status({type:'PRICE',ageHours:12,verified:true})==='FRESH');
  ok('price decays quickly',status({type:'PRICE',ageHours:60,verified:true})==='STALE');
  ok('fundamental data decays slower',status({type:'FUNDAMENTAL',ageHours:60,verified:true})==='FRESH');
  ok('unverified fresh data stays distinct',status({type:'NEWS',ageHours:8,verified:false})==='FRESH_UNVERIFIED');
  ok('unknown age remains unknown',status({type:'MACRO',verified:true})==='UNKNOWN');
  ok('fresh verified has full factor',factor({type:'NEWS',ageHours:8,verified:true})===1);
  ok('stale evidence is downweighted',factor({type:'NEWS',ageHours:200,verified:true})<1);
  ok('unverified fresh evidence needs refresh',refreshNeeded({type:'NEWS',ageHours:8,verified:false})===true);
  const b=bundle([{type:'PRICE',ageHours:80,verified:true},{type:'FUNDAMENTAL',ageHours:100,verified:true}]);
  ok('bundle identifies stale item',b.stale.length===1);
  ok('bundle remains non-trading',b.tradeSignal===false);
  return Object.freeze({passed:t.filter(x=>x.pass).length,total:t.length,tests:Object.freeze(t)});
}
const API={VERSION,DEFAULTS,normalize,status,factor,refreshNeeded,bundle,selfTest};
try{API.selfTestResult=selfTest()}catch(e){API.bootstrapError=String(e&&e.stack||e)}
global.ZooInvestEvidenceFreshnessEngine=Object.freeze(API);
})(engineContext);
